const CRM_SUPABASE_URL = "https://ppkeqfebxjjbxufxuqlt.supabase.co";
const CRM_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBwa2VxZmVieGpqYnh1Znh1cWx0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEwMzkzMTQsImV4cCI6MjA4NjYxNTMxNH0.E5rhBu3s94i5ZatvTTvCBSxuyZSzUUImSXJ2kunfSIQ";

const headers = {
  apikey: CRM_ANON_KEY,
  Authorization: `Bearer ${CRM_ANON_KEY}`,
  "Content-Type": "application/json",
};

export const CRM_FORM_ID = "02fe9e03-19d7-461a-a265-1fc614a39234";

export interface FormField {
  id: string;
  form_id: string;
  label: string;
  type: string;
  required: boolean;
  position: number;
  options: string[] | null;
  placeholder: string | null;
}

export async function fetchFormFields(formId: string): Promise<FormField[]> {
  const res = await fetch(
    `${CRM_SUPABASE_URL}/rest/v1/form_fields?form_id=eq.${formId}&order=position.asc`,
    { headers }
  );

  if (!res.ok) {
    throw new Error(`Failed to fetch form fields: ${res.status}`);
  }

  return res.json();
}

export async function submitFormToCRM(
  formId: string,
  data: Record<string, string>,
  consentText: string
): Promise<void> {
  const res = await fetch(
    `${CRM_SUPABASE_URL}/functions/v1/process-form-submission`,
    {
      method: "POST",
      headers: {
        apikey: CRM_ANON_KEY,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        form_id: formId,
        data,
        consent: {
          given_at: new Date().toISOString(),
          text: consentText,
        },
      }),
    }
  );

  if (!res.ok) {
    const errorBody = await res.text();
    throw new Error(`Erro ao enviar formulário: ${res.status} - ${errorBody}`);
  }
}
